import { useEffect } from "react";
import { Link } from "react-router-dom";
import { nhanTram, linkTram, tramTiepTheo, SO_TRAM } from "../data/lo-trinh.js";
import { TOOLS } from "../data/tools.js";
import { track, trackOnce } from "../lib/track.js";

/**
 * Nhãn "Trạm 4/5 · Hồ sơ trình bày" ngay dưới breadcrumb của trang bài
 * Playbook, công cụ và mẫu. Bấm vào thì tới đúng trạm trên /lo-trinh.
 *
 * Slug chưa được gắn trạm (tram = null) thì không hiện gì: bài mới viết qua
 * /admin/playbook sẽ rơi vào trường hợp này cho tới khi thêm vào lo-trinh.js.
 * Được render sẵn lúc build, nên chỉ phụ thuộc dữ liệu tĩnh.
 */
export default function NhanTram({ tram, trang }) {
  useEffect(() => {
    if (tram) trackOnce(`tram:${trang}:${tram.id}:${window.location.pathname}`, "xem_nhan_tram", { tram: tram.id, trang });
  }, [tram, trang]);
  if (!tram) return null;
  return (
    <p className="nhan-tram">
      <Link to={linkTram(tram)}>
        <span className="nhan-tram-so" aria-hidden="true">{tram.so === 0 ? "◎" : tram.so}</span>
        {nhanTram(tram)}
      </Link>
    </p>
  );
}

const congCuTheoSlug = (slug) => TOOLS.find((t) => t.slug === slug) || null;

/**
 * Cuối bài Playbook: thay "Đọc tiếp" bằng trạm kế tiếp trên lộ trình, kèm
 * công cụ chính của trạm đó. Ở trạm cuối thì chúc và đưa về Bản chuẩn bị.
 */
export function TramTiepTheo({ tram }) {
  if (!tram) return null;
  const tiep = tramTiepTheo(tram);
  if (!tiep) {
    return (
      <aside className="tram-tiep surface" aria-labelledby="tram-tiep-tieu-de">
        <p className="eyebrow">TRẠM CUỐI: {tram.ten.toUpperCase()}</p>
        <h2 id="tram-tiep-tieu-de">Bạn đã đi hết lộ trình</h2>
        <p>
          Chúc bạn gửi hồ sơ suôn sẻ và gặp đúng nhà đầu tư. Mọi con số, tài liệu
          và danh sách quỹ bạn đã chuẩn bị đều nằm trong Bản chuẩn bị.
        </p>
        <div className="hang-nut">
          <Link
            className="nut"
            to="/ban-chuan-bi"
            onClick={() => track("bam_tram_tiep_theo", { tu_tram: tram.id, den_tram: "ban-chuan-bi" })}
          >
            Mở Bản chuẩn bị của tôi →
          </Link>
          <Link className="nut phu" to="/lo-trinh">Xem lại lộ trình</Link>
        </div>
      </aside>
    );
  }
  const congCu = congCuTheoSlug(tiep.congCuChinh);
  const ghi = () => track("bam_tram_tiep_theo", { tu_tram: tram.id, den_tram: tiep.id });
  return (
    <aside className="tram-tiep surface" aria-labelledby="tram-tiep-tieu-de">
      <p className="eyebrow">TRẠM TIẾP THEO ({tiep.so}/{SO_TRAM})</p>
      <h2 id="tram-tiep-tieu-de">{tiep.ten}</h2>
      <p className="tram-tiep-hoi">{tiep.cauHoi}</p>
      <div className="hang-nut">
        {congCu && (
          <Link className="nut" to={`/cong-cu/${congCu.slug}`} onClick={ghi}>
            {congCu.title} →
          </Link>
        )}
        <Link className={congCu ? "nut phu" : "nut"} to={linkTram(tiep)} onClick={congCu ? undefined : ghi}>
          Xem cả trạm {tiep.so}
        </Link>
      </div>
    </aside>
  );
}
